"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MISSING_APPLICATION_PARAM_WARNING_MSG = exports.LOCALE = exports.ipCountryCookie = exports.STORE_ID = exports.STORE = exports.pageTypes = exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["Home"] = "home";
    PageType["Search"] = "search";
    PageType["Favorites"] = "favorites";
    PageType["Trending"] = "trending";
    PageType["LandingPage"] = "landing-page";
    PageType["YourTech"] = "your-tech";
    PageType["SubCategory"] = "sub-category";
    PageType["HowItWorks"] = "how-it-works";
    PageType["Category"] = "category";
    PageType["Deals"] = "deals";
    PageType["Pdp"] = "pdp";
    PageType["Others"] = "others";
    PageType["Referrals"] = "referrals";
    PageType["Referred"] = "referred";
    PageType["YourProfile"] = "your-profile";
    PageType["YourPayments"] = "your-payments";
    PageType["ForBusiness"] = "for-business";
    PageType["GExplore"] = "g-explore";
    PageType["Webview"] = "webview";
    PageType["Card"] = "card";
    PageType["Cart"] = "cart";
    PageType["AddOnDetails"] = "add-on-details";
    PageType["Brand"] = "brand";
})(PageType || (exports.PageType = PageType = {}));
exports.pageTypes = Object.values(PageType);
var STORE;
(function (STORE) {
    STORE["DE"] = "de";
    STORE["NL"] = "nl";
    STORE["ES"] = "es";
    STORE["AT"] = "at";
    STORE["US"] = "us";
    STORE["BUSINESS"] = "business";
    STORE["BUSINESS_NL"] = "business_nl";
    STORE["BUSINESS_ES"] = "business_es";
    STORE["BUSINESS_AT"] = "business_at";
    STORE["BUSINESS_US"] = "business_us";
})(STORE || (exports.STORE = STORE = {}));
// production store id
exports.STORE_ID = (_a = {},
    _a[STORE.DE] = 1,
    _a[STORE.NL] = 5,
    _a[STORE.ES] = 618,
    _a[STORE.AT] = 4,
    _a[STORE.US] = 621,
    _a[STORE.BUSINESS] = 126,
    _a[STORE.BUSINESS_NL] = 626,
    _a[STORE.BUSINESS_ES] = 627,
    _a[STORE.BUSINESS_AT] = 622,
    _a[STORE.BUSINESS_US] = 629,
    _a);
exports.ipCountryCookie = 'ipCountry';
var LOCALE;
(function (LOCALE) {
    LOCALE["EN"] = "en";
    LOCALE["DE"] = "de";
    LOCALE["NL"] = "nl";
    LOCALE["ES"] = "es";
})(LOCALE || (exports.LOCALE = LOCALE = {}));
exports.MISSING_APPLICATION_PARAM_WARNING_MSG = 'The application property is missing and will be required in future versions.';
//# sourceMappingURL=constants.js.map